module.exports = {"school-name":"University of Idaho","logo":"/sites/uofi/logo.png","logout":"/sites/uofi/logout.png","logout-color":"#F1B300","logout-font-color":"#191919","header-color":"#191919","header-border-color":"#F1B300","footer-color":"#191919","footer-info":"© 2019 University of Idaho | The Write Class™ | © 2019 Boise State University","help-button-color":"#F1B300","help-button-font-color":"#191919"}


//////////////////
// WEBPACK FOOTER
// ./sites/uofi/site-config.json
// module id = 116
// module chunks = 12